import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import { DashBoardMovimentosDto, ReadDefensoriaDto, ReadNucleoDto } from '@/api.types';
import { GetDashboardMovimentos } from '@/modules/home/dashboards.service';
import { LOCALIZACAO_SISTEMA } from '@/shared/constants/strings';
import { Link } from 'react-router-dom';
import { TbClockQuestion } from 'react-icons/tb';
import { convertToGMTPlus3, DataAmigavel, DataIso } from '@/shared/utils/datas';
import { toast } from 'react-toastify';
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

export interface parametros {
  referenciaI: string;
  referenciaF: string;
  defensoria: number;
  nucleo: number;
  defensor: number;
  defensorias: ReadDefensoriaDto[];
  nucleos: ReadNucleoDto[];
}

const TabelaMovimentos = forwardRef((props: parametros, ref) => {
  const [registros, setRegistros] = useState<DashBoardMovimentosDto[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [pendentes, setPendentes] = useState<boolean>(true);
  const [aplicarFiltro, setAplicarFiltro] = useState(false);

  useEffect(() => {
    if (props.referenciaI && props.referenciaF) {
      buscarRegistros();
    }
  }, []);

  useImperativeHandle(ref, () => ({
    buscarRegistros,
  }));

  const buscarRegistros = () => {
    const { referenciaI, referenciaF, defensoria, nucleo, defensor } = props;

    if (!referenciaI || !referenciaF) return;

    const df = convertToGMTPlus3(referenciaF);
    df.setDate(new Date(df.getFullYear(), df.getMonth() + 1, 0).getDate());

    setLoading(true);
    setAplicarFiltro(true);

    GetDashboardMovimentos(
      DataIso(referenciaI),
      DataIso(df),
      defensoria,
      nucleo,
      defensor,
    )
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(res as string);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (aplicarFiltro) {
      buscarRegistros();
      setAplicarFiltro(false);
    }
  }, [aplicarFiltro]);

  if (loading) return Loading();

  return (
    <>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="pendentes"
          onChange={(e) => {
            setPendentes(e.target.checked);
          }}
          checked={pendentes || false}
        />
        <label className="form-check-label" htmlFor="pendentes">
          Pendentes.
        </label>
      </div>
      <div>
        <table className="table table-sm table-striped table-hover">
          <thead className="">
            <tr className="justify-content-center">
              <th>Referência</th>
              <th>Defensor(a)</th>
              <th>Defensoria/Núcleo</th>
              <th>Prazo de Entrega</th>
              <th>Recebimentos</th>
              <th>Atendimentos</th>
              <th>Relatorios</th>
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {/* Para cada defensor */}
            {registros &&
              registros.map((defensor, index) => {
                // Para cada período de referência
                return defensor.referencias.map((relatorio, index2) => {
                  const nomeDefensoriaNucleo = relatorio.defensoria_id
                    ? props.defensorias.find(
                      (a) => a.id == relatorio.defensoria_id,
                    )?.nome
                    : relatorio.nucleo_id
                      ? props.nucleos.find((a) => a.id == relatorio.nucleo_id)
                        ?.nome
                      : '';

                  const nomeDefensor = defensor.defensor_nome.split(' ');

                  if (
                    (pendentes && relatorio.entregas) ||
                    (!pendentes && !relatorio.entregas)
                  )
                    return;

                  return (
                    <tr
                      key={'d_' + index + 'r_' + index2}
                      className="align-middle"
                    >
                      <td>
                        {new Date(relatorio.data_referencia).toLocaleDateString(
                          LOCALIZACAO_SISTEMA,
                          {
                            year: 'numeric',
                            month: 'short',
                          },
                        )}
                      </td>
                      <td>
                        {nomeDefensor[0]}{' '}
                        {nomeDefensor[nomeDefensor.length - 1]}
                      </td>
                      <td>{nomeDefensoriaNucleo}</td>
                      <td>{DataAmigavel(relatorio.data_prazo)}</td>

                      {relatorio.entregas && (
                        <>
                          <td>
                            {relatorio.entregas.map((element, idx) => {
                              return (
                                <React.Fragment key={`recebimento-${idx}`}>
                                  {DataAmigavel(element.data_recebimento)}
                                  {relatorio.entregas.length > 1 && <br />}
                                </React.Fragment>
                              );
                            })}
                          </td>
                          <td>
                            {relatorio.entregas.map((element, idx) => {
                              return (
                                <React.Fragment key={`atendimento-${idx}`}>
                                  {element.atendimentos}
                                  {relatorio.entregas.length > 1 && <br />}
                                </React.Fragment>
                              );
                            })}
                          </td>
                          <td>
                            {relatorio.entregas.map((entrega, idx) => {
                              let textoLink = 'Registro';
                              if (entrega.civel && entrega.criminal)
                                textoLink = 'Registro';
                              else if (entrega.civel) textoLink = 'Cível';
                              else if (entrega.criminal) textoLink = 'Criminal';

                              const ehNucleo = Boolean(
                                relatorio.nucleo_id || entrega.nucleo,
                              );
                              const href =
                                `${Links.Movimentacoes_Editar}/${entrega.movimento_id}` +
                                `?ehnucleo=${ehNucleo ? 'true' : 'false'}`;

                              return (
                                <React.Fragment key={`entrega-${idx}-${entrega.movimento_id}`}>
                                  <Link
                                    to={href}
                                    title="Ver como o registro foi gravado."
                                    target="_blank"
                                  >
                                    {textoLink}
                                  </Link>
                                  {relatorio.entregas.length > 1 && <br />}
                                </React.Fragment>
                              );
                            })}
                          </td>
                        </>
                      )}

                      {!relatorio.entregas && (
                        <>
                          <td
                            colSpan={3}
                            className="text-center"
                            title="Pendente"
                          >
                            <TbClockQuestion
                              title="Pendente"
                              className="text-center align-middle"
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                });
              })}
            {registros && registros?.length <= 0 && (
              <tr>
                <td colSpan={7}>Nenhum registro encontrado</td>
              </tr>
            )}
            <tr>
              <td className="fw-bold" colSpan={5}>
                TOTAL
              </td>
              <td colSpan={2}>
                {registros &&
                  !pendentes &&
                  registros.reduce((acumulador, currentValue) => {
                    const totalAtendimentos = currentValue.referencias
                      .flatMap((ref) =>
                        Array.isArray(ref.entregas) ? ref.entregas : [],
                      )
                      .reduce((acumulador2, entrega) => {
                        return (
                          Number(acumulador2) +
                          Number(entrega?.atendimentos || 0)
                        );
                      }, 0);
                    return Number(acumulador) + totalAtendimentos;
                  }, 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
});

export default TabelaMovimentos;
